<template>
  <div>
    <b-form-group>
      <b-button
        :disabled="disabled"
        variant="outline-secondary"
        @click="showModal = true">
        <i class="fas fa-plus"></i>
        Add Modules
      </b-button>
      <br>
      {{ taggedModules.length }} tagged
      <br>
    </b-form-group>

    <b-modal
      v-model="showModal"
      title="Modules"
      centered hide-footer
      size="lg">
      <modules-table
        v-if="showModal"
        :view="view"
        :ids-to-highlight="taggedModules"
        context="select"
        @removeAll="removeAll"
        @selectModule="addModuleRelation"/>
      <b-button
        variant="outline-primary"
        class="mt-3"
        block
        @click="showModal = false">
        Done Selecting
      </b-button>
    </b-modal>

  </div>
</template>

<script>
import modulesTable from './table'
import { mapState } from 'vuex'

export default {
  components: {
    modulesTable
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    initialModules: {
      type: Array,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      taggedModules: []
    }
  },
  computed: {
    ...mapState('modules', {
      view: '_defaultView'
    }),
    modules () {
      return this.$store.getters['modules/view'](this.view)
    }
  },
  mounted () {
    this.taggedModules = this.initialModules
    this.updateStore()
  },
  methods: {
    updateStore () {
      this.$store.commit(`${this.namespace}/forms/relateModules/setField`, {
        field: 'moduleIDs',
        value: this.taggedModules
      })
    },
    removeAll () {
      this.taggedModules = []
      this.updateStore()
    },
    addModuleRelation (module) {
      // toggle inclusion of modules
      let idx
      let exists = false
      for (let i=0; i<this.taggedModules.length; i++) {
        if (this.taggedModules[i] === module.id) {
          exists = true
          idx = i
        }
      }

      if (exists) {
        this.taggedModules.splice(idx, 1)
      } else {
        this.taggedModules.push(module.id)
      }

      this.updateStore()
    },
    reset (event) {
      this.taggedModules = this.initialModules
      this.$store.commit(`${this.namespace}/forms/relateModules/resetState`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/modules/relateModules.vue